"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// (C) 2019 GoodData Corporation
require("@formatjs/intl-pluralrules");
require("@formatjs/intl-pluralrules/polyfill-locales");
//# sourceMappingURL=polyfills.js.map